type ErrorNotificationProps = {
  message: string;
};

const ErrorNotification = ({ message }: ErrorNotificationProps) => {
  return (
    <div className="mt-2 flex items-center gap-3 rounded-xl border border-red-500/40 bg-red-500/10 shadow-lg px-4 py-3 text-sm text-red-600 dark:text-red-400">
      {message}
    </div>
  );
};

export default ErrorNotification;
